// src/components/Header.js
import React from 'react';
import '../styles/Header.css'; // Create styles for the header

const Header = () => {
  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <img src="/logo.png" alt="Logo" className="logo-img" />
        </div>
      </div>
    </header>
  );
};

export default Header;
